import React from 'react';
import styled from 'styled-components';
import Calendar from "../../../components/common/CustomCalendar";

const CalendarView = (props) => {
return(
  <Container>
    <Calendar {...props} />
  </Container>
)

}
export default CalendarView;

const Container = styled.div`
    height: 100%;
`;